import { AiStoryModel } from 'interface/models';

export function safe_json_pare(val: any) {
  if (!val) {
    return val;
  }
  try {
    if (typeof val === 'string') {
      return JSON.parse(val);
    }
    return val;
  } catch (e) {
    console.error('Error parsing JSON', e.message, `Value: ` + val);
    return {};
  }
}

export function getPromtVars(story: AiStoryModel) {
  if (!story) {
    return [];
  }

  const extraVars = safe_json_pare(story?.extraVars);
  const myVars = Object.keys(safe_json_pare(story?.extraVars) || {});

  const storyVars = ['initMessage', 'ttsText', 'fraimsCount', 'promtTemplate', 'promtTemplateIntro', 'promtMutator'];
  return [
    ...myVars.map(key => {
      return {
        value: key,
        label: key + ` - ${String(extraVars[key]).slice(0, 50)}`,
      };
    }),
    ...storyVars.map(key => {
      return {
        value: key,
        label: key + ` - ${String(story[key]).slice(0, 50)}`,
      };
    }),
    {
      value: 'format',
      label: 'format',
    },
  ];
}
